'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoBriefcase = function GoBriefcase(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 7.5h-10v-2.6c0-1.3-1.1-2.4-2.4-2.4h-5.2c-1.3 0-2.4 1.1-2.4 2.4v2.6h-10c-1.4 0-2.5 1.1-2.5 2.5v20c0 1.4 1.1 2.5 2.5 2.5h30c1.4 0 2.5-1.1 2.5-2.5v-20c0-1.4-1.1-2.5-2.5-2.5z m-17.5-1.9c0-0.3 0.3-0.6 0.6-0.6h3.8c0.3 0 0.6 0.3 0.6 0.6v1.9h-5v-1.9z m17.5 14.4h-12.5v2.5h-5v-2.5h-12.5v-10h2.5v7.5h25v-7.5h2.5v10z' })
        )
    );
};

exports.default = GoBriefcase;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/briefcase.js
// module id = 1871
// module chunks = 0